import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Portfolio = ({ data }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  if (!data) return null;

  const { projects: projectsData } = data;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const projectVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeInOut" } },
  };

  const projects = projectsData.map((project) => {
    const projectImage = "images/portfolio/" + project.image;
    return (
      <motion.div key={project.title} className="columns portfolio-item" variants={projectVariants}>
        <div className="item-wrap">
          <motion.img 
            alt={project.title} 
            src={projectImage} 
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          />
          <div className="overlay">
            <div className="portfolio-item-meta">
              <h5>{project.title}</h5>
              <p>{project.category}</p>
            </div>
          </div>
          <div className="link-icon">
            <i className="fa fa-link"></i>
          </div>
        </div>
      </motion.div>
    );
  });

  return (
    <section id="portfolio" ref={ref}>
      <div className="row three ">
        <div className="twelve columns collapsed">
          <h1>Some of My Work.</h1>

          <motion.div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf"
            variants={containerVariants}
            initial="hidden"
            animate={controls}
          >
            {projects}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
